export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-2xl font-heading font-bold text-primary-400 whitespace-nowrap">
              爆瓜网
            </span>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed max-w-xs">
              爆瓜网是国内领先的娱乐八卦资讯聚合平台，每日更新最新明星八卦、网红爆料、娱乐热点，让吃瓜群众一手掌握全网热门爆料合集。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 text-background-100 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 text-background-100 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 text-background-100 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-5">快速导航</h4>
            <ul className="space-y-3">
              {[
                { label: '视频爆料', href: '#media' },
                { label: '最新快讯', href: '#updates' },
                { label: '热搜榜', href: '#ranking' },
                { label: '专题合集', href: '#index' },
                { label: '热门话题', href: '#topics' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-5">热门话题</h4>
            <ul className="space-y-3">
              {[
                { label: '明星恋情实锤', href: '#topics' },
                { label: '综艺争议内幕', href: '#topics' },
                { label: '网红翻车现场', href: '#topics' },
                { label: '娱乐圈重磅消息', href: '#topics' },
                { label: '深度吃瓜分析', href: '#cards' },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-5">合作伙伴</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
            <div className="mt-6">
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2.5 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line"></i>
                联系我们
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 爆瓜网. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}